<template lang='pug'>
div

    UHFSensorSelectorLinks

    div.fullwidth(v-if="$route.params.lang == 'en'")

        section.title-container
            h1.product-title UHF-DVS-50 
            h2.product-subtitle UHF Drain Valve Sensor for Retrofit at the DN50 / DN80 Oil Valves of Transformers during Operation

        section.margin-bottom
            .column-container
                .column.center-content
                    picture.main-product-picture
                        source(type='image/webp', srcset='@/assets/photos/product_shots/UHF-DVS-50.webp')
                        img( src='@/assets/photos/product_shots/UHF-DVS-50.png', width="100%", alt='UHF PD Sensor UHF-DVS-50', title='UHF PD Sensor UHF-DVS-50')
                .column.factsandbluebox
                    .factbox
                        span.headline Key Features:
                        ul
                            li For oil-filled transformers
                            li Insertion depth max. 410 mm
                            li Bandwidth: 100 MHz ... 3 GHz
                            li Retrofit possible at DN50 and DN80 valves
                            li Integrated high-pass filter
                            li Antenna fully retractable
                    .bluebox                        
                        Downloadlink(text='Datasheet (pdf, english)', link="/pdf/Datasheet UHF-DVS-50.pdf")
                        Maillink(to='support@bss-hs.de', sub='UHF-DVS-50', text='Contact Us', size=30, strokeWidth=2)
                        Sitelink(to="/en/products/pdm-600", text='UHF PD Monitoring System PDM-600')
                        Sitelink(to="/en/products/PDM-600-Mobile", text='PDM-600-Mobile')
                        Sitelink(to="/en/products/pdaccessories/overview", text='PD Accessories')
                    
        section.margin-bottom
            p The UHF PD sensor UHF-DVS-50 for DN50 / DN80 valves is suitable for measuring of electromagnetic radiation by internal partial discharges (PD) in the ultra-high frequency (UHF) range in transformers. The sensor can be inserted via standardized DN50 and DN80 gate valves into the transformer tank. This can be done even if the transformer is in service. This type of sensor is typically used for diagnostic PD measurements and can also be used for permanent monitoring of PD. The advantage of UHF measurements compared to conventional electric measurements is its selectivity: high external noise which often occurs at onsite measurements have only little effect on internal UHF PD measurements.


    div.fullwidth(v-if="$route.params.lang == 'de'")

        section.title-container
            h1.product-title UHF-DVS-50
            h2.product-subtitle UHF-TE-Sensor für die Nachrüstung an DN50 und DN80 Ölschiebern

        section.margin-bottom
            .column-container
                .column.center-content
                    picture.main-product-picture
                        source(type='image/webp', srcset='@/assets/photos/product_shots/UHF-DVS-50.webp')
                        img( src='@/assets/photos/product_shots/UHF-DVS-50.png', width="100%", alt='UHF-TE-Sensor UHF-DVS-50', title='UHF-TE-Sensor UHF-DVS-50')
                .column.factsandbluebox
                    .factbox
                        span.headline Highlights:
                        ul
                            li Für ölgefüllte Transformatoren
                            li Einschubtiefe max. 410 mm
                            li Bandbreite: 200 MHz ... 3 GHz
                            li Installation an vorhandenen DN50 und DN80 Schiebern
                            li Integrierter Hochpassfilter
                            li Sensorkopf vollständig zurückziehbar
                    .bluebox
                        Downloadlink(text='Datenblatt (pdf, englisch)', link="/pdf/Datasheet UHF-DVS-50.pdf")
                        Maillink(to='support@bss-hs.de', sub='UHF-DVS-50', text='Kontakt', size=30, strokeWidth=2)
                        Sitelink(to="/de/products/pdm-600", text='UHF-TE-Monitoringsystem PDM-600')
                        Sitelink(to="/de/products/PDM-600-Mobile", text='PDM-600-Mobile')
                        Sitelink(to="/de/products/pdaccessories/overview", text='TE-Zubehör')
                    
        section.margin-bottom
            p Der UHF-TE-Sensor UHF-DVS-50 für die Installation an DN50 / DN80 Schiebern ist zur Messung der elektromagnetischen Abstrahlung von Teilentladungen (TE) im ultrahochfrequenten (UHF) Bereich im Transformator geeignet. Der Sensor kann über standardisierte DN50 und DN80 Absperrschieber in den Transformatorkessel eingebracht werden; dies kann im laufenden Betrieb geschehen. Dieser Sensortyp wird typischerweise bei Diagnosemessungen und für dauerhaftes TE-Monitoring verwendet. Ein großer Vorteil der UHF-Messung gegenüber konventioneller elektrischer Messung ist ihre Selektivität: externe Störsignale, wie sie z.B. häufig bei vor Ort Messungen vorkommen, beeinflussen die Messung der inneren Transformator-TE wenig.


</template>

<script>
export default {
    meta: {
        de: {
            title: "BSS | UHF-DVS-50",
            description:
                "UHF-TE-Sensor für die Nachrüstung an DN50 und DN80 Ölschiebern",
        },
        en: {
            title: "BSS | UHF-DVS-50",
            description:
                "UHF Drain Valve Sensor for Retrofit at the DN50 / DN80 Oil Valves of Transformers",
        },
    },
};
</script>

<style scoped lang='sass'>
</style>